import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  exportToCSV,
  exportToExcel,
} from "../core/common/GlobalFunctions/exportTableData";
import { getEmployees } from "../core/data/redux/employee/employeeAction";
import dayjs from "dayjs";
import { AppDispatch } from "../core/data/redux/store";
import { fetchAllLeaveRequests } from "../core/data/redux/attendance/leave/leaveAction";
import { fetchSalaryTransactions } from "../core/data/redux/payroll/payrollSalary/salaryTransaction/salaryTransactionActions";
import { fetchAllExpenses } from "../core/data/redux/payroll/Accounting/expenses/expenseActions";
import { getUsers } from "../core/data/redux/user/userAction";
import { fetchAllPaySlipReport } from "../core/data/redux/reports/paySlip_report/payslipAction";
import { fetchAllemployeeReport } from "../core/data/redux/reports/employee_report/employeereport.Action";
import { fetchAllOffboardingReport } from "../core/data/redux/reports/offboarding_report/offboarding.Action";
import { fetchAllEmployeeSkills } from "../core/data/redux/reports/skills_report/skillsreport.Action";
import { fetchAllEmployeeData } from "../core/data/redux/reports/timesheet_report/timesheet.Action";
import { fetchAllProjectReport } from "../core/data/redux/reports/project_report/project.Action";
import { fetchAllTaskList } from "../core/data/redux/reports/task_report/task.Action";
import { fetchAllBudgets } from "../core/data/redux/payroll/Accounting/budgets/budgetsAction";
import { fetchAllAllocations } from "../core/data/redux/asset/assetAllocation/assetAllocationActions";
import { fetchAllMaintenances } from "../core/data/redux/asset/assetMaintenanceAction/assetMaintenanceAction";
import { fetchAlltraininglist } from "../core/data/redux/training/trainingAction";
import { fetchAllattendanceReport } from "../core/data/redux/reports/attendance_report/attendacnereport.Action";
import { fetchAllLeaveledgerReport } from "../core/data/redux/reports/leaveledger/leaveledger.Action";
import { fetchAllTDSAction } from "../core/data/redux/reports/tds_report/tds.Action";

export default function GlobalExportListener() {
  const dispatch = useDispatch<AppDispatch>();
  const [payslipData, setPayslipData] = useState<any[]>([]);
  const [payslipLoading, setPayslipLoading] = useState(false);
  const [employeeReportData, setEmployeeReportData] = useState<any[]>([]);
  const [employeeReportLoading, setEmployeeReportLoading] = useState(false);
  const [offboardingData, setOffboardingData] = useState<any[]>([]);
  const [offboardingLoading, setOffboardingLoading] = useState(false);
  const [skillsData, setSkillsData] = useState<any[]>([]);
  const [skillsLoading, setSkillsLoading] = useState(false);
  const [employeeTimesheetData, setEmployeeTimesheetData] = useState<any[]>([]);
  const [employeeTimesheetLoading, setEmployeeTimesheetLoading] =
    useState(false);
  const [projectData, setProjectData] = useState<any[]>([]);
  const [projectLoading, setProjectLoading] = useState(false);
  const [taskData, setTaskData] = useState<any[]>([]);
  const [taskLoading, setTaskLoading] = useState(false);
  const [attendanceReportData, setAttendanceReportData] = useState<any[]>([]);
  const [attendanceReportLoading, setAttendanceReportLoading] = useState(false);
  const [tdsReportData, setTdsReportData] = useState<any[]>([]);
  const [tdsReportLoading, setTdsReportLoading] = useState(false);

  const employees = useSelector((state: any) => state.employee.employees);
  const employeeLoading = useSelector((state: any) => state.employee.loading);
  const leaveData = useSelector(
    (state: any) => state.attendance.leaveRequests.leaveRequests || []
  );
  const leaveLoading = useSelector(
    (state: any) =>
      state.attendance.leaveRequests.loadingStates?.fetchAll || false
  );
  const salaryTransactions = useSelector(
    (state: any) => state.payroll.salaryTransaction.salaryTransactions
  );
  const salaryLoading = useSelector(
    (state: any) => state.payroll.salaryTransaction.loading
  );
  const selectExpenses = useSelector(
    (state: any) => state.accounting.expenses.records
  );
  const selectExpenseLoading = useSelector(
    (state: any) => state.accounting.expenses.loadingStates
  );
  const userData = useSelector((state: any) => state.user.totalUsers);
  const userLoading = useSelector((state: any) => state.user.loading);
  const budgetData = useSelector(
    (state: any) => state.accounting.budget.budgets
  );
  const budgetLoading = useSelector(
    (state: any) => state.accounting.budget.loadingStates
  );
  const assetData = useSelector(
    (state: any) => state.asset.assetAllocation.assetAllocations
  );
  const assetLoading = useSelector(
    (state: any) => state.asset.assetAllocation.loading
  );
  const maintenanceData = useSelector(
    (state: any) => state.asset.assetMaintenance.maintenances
  );
  const maintenanceLoading = useSelector(
    (state: any) => state.asset.assetMaintenance.loadingStates
  );

  const trainingData = useSelector(
    (state: any) => state.training.training.training
  );
  const trainingLoading = useSelector(
    (state: any) => state.training.training.loading
  );

  const exportRequestRef = useRef<any>(null);

  const leaveledgerData = useSelector(
    (state: any) => state.attendance.leaveRequests.leaveRequests || []
  );
  const leaveledgerLoading = useSelector(
    (state: any) =>
      state.attendance.leaveRequests.loadingStates?.fetchAll || false
  );

  // Format employees
  const formattedEmployeeData = employees?.map((item: any) => ({
    employeeId: item.EmployeeID,
    EmployeeCode: item.EmployeeNumber,
    name: item.Name,
    email: item.email,
    Phone: item.Phone,
    DateOfBirth: item.DateOfBirth
      ? dayjs(item.DateOfBirth).format("YYYY-MM-DD")
      : "",
    Gender: item.GenderId === 1 ? "Male" : "Female",
    DateOfJoining: item.DateOfJoining
      ? dayjs(item.DateOfJoining).format("YYYY-MM-DD")
      : "",
    Designation: item.designation_name || "N/A",
    Department: item.department_name || "N/A",
    Status: item.employee_status === "active" ? "Active" : "Inactive",
    WorkPreference: item.WorkPreference,
    EmploymentType:
      item.EmploymentType === "full-time" ? "Full-time" : "Part-time",
    PFEnabled: item.pfEnable === 1 ? "Yes" : "No",
    JobLocation: item.job_location,
    Role: item.role_name,
    Description: item.Description,
  }));

  // Format leave data
  const formattedLeaveData = (leaveData || []).map((item: any) => ({
    EmployeeName: item.employeeName,
    EmployeeNumber: item.EmployeeNumber,
    LeaveType: item.LeaveType,
    Description: item.Description,
    FromDate: item.FromDate ? dayjs(item.FromDate).format("YYYY-MM-DD") : "",
    ToDate: item.ToDate ? dayjs(item.ToDate).format("YYYY-MM-DD") : "",
    Duration: item.Duration,
    Status: item.LeaveRequestStatus,
    LeaveMode: item.LeaveMode,
  }));

  const formattedleaveledgerData = (leaveledgerData || []).map((item: any) => ({
    ID: item.Id,
    EmployeeName: item.employeeName,
    EmployeeNumber: item.EmployeeNumber,
    LeaveType: item.LeaveType,
    Description: item.Description,
    FromDate: item.FromDate ? dayjs(item.FromDate).format("YYYY-MM-DD") : "",
    ToDate: item.ToDate ? dayjs(item.ToDate).format("YYYY-MM-DD") : "",
    Duration: item.Duration,
    Status: item.LeaveRequestStatus,
    LeaveMode: item.LeaveMode,
    CancellationStatus: item.Cancellation_status || "N/A",
    CreatedAt: item.CreatedAt ? dayjs(item.CreatedAt).format("YYYY-MM-DD") : "",
    LeaveTypeFrequency: item.LeaveTypeFrequency,
  }));
  // Format salary data
  const formattedSalaryData = (salaryTransactions || []).map((item: any) => ({
    EmployeeName: item.EmployeeName,
    EmployeeCode: item.EmployeeNumber,
    Month: item.month_name,
    Year: new Date(item.payment_date).getFullYear(),
    BasicSalary: item.salary,
    Allowances:
      item.earnings_json?.map((earning: any) => earning.amount).join(", ") ||
      "N/A",
    Deductions:
      item.deductions_json
        ?.map((deduction: any) => deduction.amount)
        .join(", ") || "N/A",
    NetSalary: item.net_salary,
    Status: item.status,
    PaymentDate: item.payment_date
      ? dayjs(item.payment_date).format("YYYY-MM-DD")
      : "",
  }));

  // Format Expense data
  const formattedExpenseData = selectExpenses?.map((item: any) => ({
    ExpenseName: item.expense_name,
    ExpenseID: item.expense_id,
    ExpenseDate: item.expense_date
      ? dayjs(item.expense_date).format("YYYY-MM-DD")
      : "",
    Amount: item.amount,
    PaymentMethod: item.payment_method,
    PaymentStatus: item.paymentStatus,
    RequestStatus: item.requestStatus,
    Status: item.status,
    CreatedBy: item.createdBy,
    CreatedAt: item.createdAt ? dayjs(item.createdAt).format("YYYY-MM-DD") : "",
  }));

  // Format User data
  const formattedUserData = (userData || []).map((item: any) => ({
    UserId: item.UserId,
    Name: item.DisplayName,
    Email: item.Email,
    Mobile: item.mobile_code + " " + item.mobile,
    RoleName: item.RoleName,
    Status: item.active_deactive === "0" ? "Active" : "Inactive",
    CreatedAt: item.CreatedAt ? dayjs(item.CreatedAt).format("YYYY-MM-DD") : "",
    ModifiedAt: item.ModifiedAt
      ? dayjs(item.ModifiedAt).format("YYYY-MM-DD")
      : "",
  }));

  // Format Payslip data
  const formatPayslipData = (data: any[]) => {
    return data.map((emp: any, index: number) => ({
      "Sr. No.": index + 1,
      EmployeeName: emp.Name || "N/A",
      PaidAmount: emp.PaidAmount || "0",
      PaidMonth: emp.PaidMonth,
      PaidYear: emp.PaidYear || "N/A",
      CreatedAt: emp.CreatedAt ? dayjs(emp.CreatedAt).format("YYYY-MM-DD") : "",
    }));
  };
  const formattedPayslipData = formatPayslipData(payslipData || []);

  const formatEmployeeReportData = (data: any[]) => {
    return data.map((emp: any, index: number) => ({
      "Sr. No.": index + 1,
      EmpID: `Emp-${emp.EmpID}`,
      EmployeeName: emp.Name,
      Email: emp.Email,
      Department: emp.Department,
      Phone: emp.Phone,
      JoiningDate: emp.JoiningDate
        ? dayjs(emp.JoiningDate).format("YYYY-MM-DD")
        : "",
      Status: emp.Status === "active" ? "Active" : "Inactive",
    }));
  };
  const formattedEmployeeReportData = formatEmployeeReportData(
    employeeReportData || []
  );

  const formatOffboardingData = (data: any[]) => {
    return data.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      EmployeeCode: `Emp-${item.EmployeeNumber}`,
      EmployeeName: item.EmployeeName || "N/A",
      Phone: item.Phone || "N/A",
      Department: item.DepartmentName || "N/A",
      Email: item.Email || "N/A",
      OffBoardingDate: item.SeparationDate
        ? dayjs(item.SeparationDate).format("YYYY-MM-DD")
        : "N/A",
    }));
  };
  const formattedOffboardingData = formatOffboardingData(offboardingData || []);

  // Format Skills data
  const formatSkillsData = (data: any[]) => {
    const formattedData: any[] = [];
    let srNo = 1;

    if (!data || !Array.isArray(data)) return [];

    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;

    data.forEach((skillCategory: any) => {
      if (
        skillCategory.employeeList &&
        Array.isArray(skillCategory.employeeList)
      ) {
        skillCategory.employeeList.forEach((employee: any) => {
          if (employee.skills && Array.isArray(employee.skills)) {
            employee.skills.forEach((skill: any) => {
              formattedData.push({
                "Sr. No.": srNo++,
                EmployeeName: employee.Name || "N/A",
                SkillName: skill.SkillName || "N/A",
                Year: currentYear,
                Month: currentMonth,
              });
            });
          }
        });
      }
    });

    return formattedData;
  };
  const formattedSkillsData = formatSkillsData(skillsData || []);

  const formatEmployeeTimesheet = (data: any[]) => {
    const rows: any[] = [];
    let sr = 1;

    data.forEach((emp: any) => {
      emp.workEntries?.forEach((entry: any) => {
        rows.push({
          "Sr. No.": sr++,
          "Employee Name": emp.employeeName,
          "Work Date": entry.work_date
            ? dayjs(entry.work_date).format("YYYY-MM-DD")
            : "",
          "Hours Logged": entry.hours_logged,
          "Total Hours": entry.total_hours,
          "Remaining Hours": entry.remaining_hours,
          "Project Name": entry.project_names || "N/A",
          "Task Name": entry.task_names || "N/A",
          Description: entry.descriptions || "",
          Status: entry.status || "Pending",
          Deadline: entry.deadline
            ? dayjs(entry.deadline).format("YYYY-MM-DD")
            : "",
        });
      });
    });

    return rows;
  };
  const formattedEmployeeTimesheet = formatEmployeeTimesheet(
    employeeTimesheetData || []
  );

  const formatProjectData = (data: any[]) => {
    const uniqueProjects = data.reduce((acc: any[], current: any) => {
      const exists = acc.find(
        (item: any) => item.project_id === current.project_id
      );
      if (!exists) {
        acc.push(current);
      }
      return acc;
    }, []);

    return uniqueProjects.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      ProjectID: item.project_id,
      ProjectName: item.project_name,
      ProjectCode: item.projectCode || "N/A",
      TotalHours: item.total_hours,
      StartDate: item.start_date
        ? dayjs(item.start_date).format("YYYY-MM-DD")
        : "",
      EndDate: item.end_date ? dayjs(item.end_date).format("YYYY-MM-DD") : "",
      PriceType: item.price_type,
      ProjectValue: item.project_value,
      Priority: item.priority,
      ProjectProgress: item.project_progress,
      TeamLead: item.team_lead_name || "N/A",
      ProjectManager: item.project_manager_name || "N/A",
      TeamMembers: item.employee_names?.join(", ") || "N/A",
      CreatedAt: item.created_at
        ? dayjs(item.created_at).format("YYYY-MM-DD")
        : "",
      Status: item.status,
    }));
  };
  const formattedProjectData = formatProjectData(projectData || []);

  // Format Task data
  const formatTaskData = (data: any[]) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      "Task Name": item.TaskName || "N/A",
      "Project Name": item.ProjectName || "N/A",
      "Created Date": item.CreatedDate
        ? dayjs(item.CreatedDate).format("YYYY-MM-DD")
        : "N/A",
      "Due Date": item.DueDate
        ? dayjs(item.DueDate).format("YYYY-MM-DD")
        : "N/A",
      Priority: item.Priority || "N/A",
      Status: item.Status || "N/A",
    }));
  };
  // Format Budget data
  const formatBudgetData = (data: any[]) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      "Budget ID": item.budget_id || "N/A",
      "Budget Title": item.budgetTitle || "N/A",
      "Budget Type": item.budgetType || "N/A",
      "Start Date": item.startDate
        ? dayjs(item.startDate).format("YYYY-MM-DD")
        : "N/A",
      "End Date": item.endDate
        ? dayjs(item.endDate).format("YYYY-MM-DD")
        : "N/A",
      "Overall Revenue": item.overallRevenue || "0",
      "Overall Expense": item.overallExpense || "0",
      "Expected Profit": item.expectedProfit || "0",
      Tax: item.tax || "0",
      "Budget Amount": item.budgetAmount || "0",
      "Project ID": item.project_id || "N/A",
      "Category ID": item.category_id || "N/A",
      Status: item.status === "active" ? "Active" : "Inactive",
      "Created At": item.createdAt
        ? dayjs(item.createdAt).format("YYYY-MM-DD")
        : "N/A",
      "Modified At": item.modifiedAt
        ? dayjs(item.modifiedAt).format("YYYY-MM-DD")
        : "N/A",
    }));
  };
  const formattedBudgetData = formatBudgetData(budgetData || []);

  // Format Asset Allocation data
  const formatAssetData = (data: any[]) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      "Allocation ID": item.allocation_id || "N/A",
      "Asset ID": item.asset_id || "N/A",
      "Asset Name": item.AssetName || "N/A",
      "Serial Number": item.serial_number || "N/A",
      "Request Number": item.RequestNumber || "N/A",
      "Employee ID": item.employee_id || "N/A",
      "Employee Name": item.EmployeeName || "N/A",
      "Employee Number": item.EmployeeNumber || "N/A",
      "Allocated By": item.allocated_by || "N/A",
      "Allocated At": item.allocated_at
        ? dayjs(item.allocated_at).format("YYYY-MM-DD HH:mm")
        : "N/A",
      "Expected Return Date": item.expected_return_date
        ? dayjs(item.expected_return_date).format("YYYY-MM-DD")
        : "N/A",
      "Actual Return Date": item.actual_return_date
        ? dayjs(item.actual_return_date).format("YYYY-MM-DD")
        : "N/A",
      "Allocation Status": item.allocation_status || "N/A",
      Remarks: item.remarks || "N/A",
      "Created At": item.CreatedAt
        ? dayjs(item.CreatedAt).format("YYYY-MM-DD HH:mm")
        : "N/A",
      "Created By": item.CreatedBy || "N/A",
      "Modified At": item.ModifiedAt
        ? dayjs(item.ModifiedAt).format("YYYY-MM-DD HH:mm")
        : "N/A",
      "Modified By": item.ModifiedBy || "N/A",
    }));
  };
  const formattedAssetData = formatAssetData(assetData || []);

  const formattedTaskData = formatTaskData(taskData || []);
  // Format Asset Maintenance data
  const formatMaintenanceData = (data: any[]) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      "Maintenance ID": item.maintenance_id || "N/A",
      "Maintenance Number": item.maintenance_number || "N/A",
      "Asset ID": item.asset_id || "N/A",
      "Asset Name": item.AssetName || "N/A",
      "Serial Number": item.SerialNumber || "N/A",
      "Maintenance Type": item.maintenance_type || "N/A",
      "Maintenance Date": item.maintenance_date
        ? dayjs(item.maintenance_date).format("YYYY-MM-DD")
        : "N/A",
      "Next Due Date": item.next_due_date
        ? dayjs(item.next_due_date).format("YYYY-MM-DD")
        : "N/A",
      Cost: item.cost || "0",
      Vendor: item.vendor_name || item.vendor || "N/A",
      Description: item.description || "N/A",
      Status: item.status || "N/A",
      "Request Status": item.request_status || "N/A",
      "Created At": item.created_at
        ? dayjs(item.created_at).format("YYYY-MM-DD HH:mm")
        : "N/A",
      "Created By": item.created_by || "N/A",
      "Modified At": item.modified_at
        ? dayjs(item.modified_at).format("YYYY-MM-DD HH:mm")
        : "N/A",
      "Modified By": item.modified_by || "N/A",
      "Employee ID": item.employeeId || "N/A",
    }));
  };
  const formattedMaintenanceData = formatMaintenanceData(maintenanceData || []);

  // Format Training data
  const formatTrainingData = (data: any[]) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      "Training ID": item.Id || "N/A",
      "Training Name": item.Name || "N/A",
      "Training Type": item.Trainingtypename || "N/A",
      Trainer: item.Trainername || "N/A",
      "Start Date": item.StartDate
        ? dayjs(item.StartDate).format("YYYY-MM-DD")
        : "N/A",
      "End Date": item.EndDate
        ? dayjs(item.EndDate).format("YYYY-MM-DD")
        : "N/A",
      "Total Duration": item.TotalDuration || "N/A",
      Cost: item.Cost || "0",
      "Training Cost": item.Trainingcost || "0",
      Status: item.Status === "active" ? "Active" : "Inactive",
      Location: item.Location || "N/A",
      Mode: item.Mode || "N/A",
    }));
  };
  const formattedTrainingData = formatTrainingData(trainingData || []);
  const formatAttendanceReportData = (data: any[]) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      "Employee ID": item.employee_id || "N/A",
      "Employee Name": item.name || "N/A",
      "Employee Code": item.EmployeeCode || "N/A",
      Department: item.department || "N/A",
      Project: item.project || "N/A",
      "Leave From Dates": item.leave_from_dates || "N/A",
      "Leave To Dates": item.leave_to_dates || "N/A",
    }));
  };
  const formattedAttendanceReportData = formatAttendanceReportData(
    attendanceReportData || []
  );

  const formatTDSReportData = (data: any[]) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any, index: number) => ({
      "Sr. No.": index + 1,
      "Employee ID": item.EmployeeID || "N/A",
      "Employee Name": item.Name || "N/A",
      "Month Year": item.MonthYear || "N/A",
      "Applicable Income": item.ApplicableIncome || "0.00",
      "Calculated Tax": item.CalculatedTax || "0.00",
      "Net Taxable Income": item.ApplicableIncome
        ? (
            parseFloat(item.ApplicableIncome) -
            (parseFloat(item.CalculatedTax) || 0)
          ).toFixed(2)
        : "0.00",
    }));
  };
  const formattedTDSReportData = formatTDSReportData(tdsReportData || []);

  useEffect(() => {
    const handler = async (event: any) => {
      const { reportType, format, year } = event.detail;
      exportRequestRef.current = { reportType, format, year };

      // Employee Export
      if (reportType === "employee") {
        if (!employees || employees.length === 0) {
          dispatch(getEmployees());
          return;
        }
        processExport(reportType, format);
      }

      // Leave Export
      else if (reportType === "leave") {
        if (!leaveData || leaveData.length === 0) {
          dispatch(fetchAllLeaveRequests());
          return;
        }
        processExport(reportType, format);
      }

      // Salary Export
      else if (reportType === "salary") {
        if (!salaryTransactions || salaryTransactions.length === 0) {
          const today = new Date();
          dispatch(
            fetchSalaryTransactions({
              year: today.getFullYear(),
              month: today.getMonth() + 1,
            })
          );
          return;
        }
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (reportType === "leaveledger") {
        if (!leaveledgerData || leaveledgerData.length === 0) {
          dispatch(fetchAllLeaveRequests());
          return;
        }
        processExport(reportType, format);
      }
      else if (reportType === "expense") {
        if (!selectExpenses || selectExpenses.length === 0) {
          dispatch(fetchAllExpenses());
          return;
        }
        processExport(reportType, format);
      }
      else if (reportType === "user") {
        if (!userData || userData.length === 0) {
          dispatch(getUsers());
          return;
        }
        processExport(reportType, format);
      }
      else if (reportType === "payslip") {
        if (!payslipData || payslipData.length === 0) {
          setPayslipLoading(true);
          try {
            const result = await dispatch(fetchAllPaySlipReport()).unwrap();
            if (result.status === "success" && result.data) {
              setPayslipData(result.data);
            } else {
              console.error("Failed to fetch payslip data:", result.message);
              exportRequestRef.current = null;
            }
          } catch (error) {
            console.error("Error fetching payslip data:", error);
            exportRequestRef.current = null;
          } finally {
            setPayslipLoading(false);
          }
          return;
        }
        processExport(reportType, format);
      }
      else if (
        reportType === "employee_report" ||
        reportType === "employeeReport"
      ) {
        if (!employeeReportData || employeeReportData.length === 0) {
          setEmployeeReportLoading(true);
          try {
            const result = await dispatch(fetchAllemployeeReport()).unwrap();
            if (result && Array.isArray(result.data)) {
              setEmployeeReportData(result.data);
            } else if (Array.isArray(result)) {
              setEmployeeReportData(result);
            } else {
              console.error(
                "Unexpected response format for employee report:",
                result
              );
              exportRequestRef.current = null;
            }
          } catch (error) {
            console.error("Error fetching employee report data:", error);
            exportRequestRef.current = null;
          } finally {
            setEmployeeReportLoading(false);
          }
          return;
        }
        processExport(reportType, format);
      }

      // Offboarding Report Export
      else if (
        reportType === "offboarding" ||
        reportType === "offboarding_report"
      ) {
        if (!offboardingData || offboardingData.length === 0) {
          setOffboardingLoading(true);
          try {
            const reportYear = year || new Date().getFullYear().toString();
            const result = await dispatch(
              fetchAllOffboardingReport(reportYear)
            ).unwrap();

            if (result.status === "success" && Array.isArray(result.data)) {
              setOffboardingData(result.data);
            } else if (Array.isArray(result)) {
              setOffboardingData(result);
            } else {
              console.error(
                "Unexpected response format for offboarding report:",
                result
              );
              exportRequestRef.current = null;
            }
          } catch (error) {
            console.error("Error fetching offboarding report data:", error);
            exportRequestRef.current = null;
          } finally {
            setOffboardingLoading(false);
          }
          return;
        }
        processExport(reportType, format);
      }
      else if (
        reportType === "skills" ||
        reportType === "employee_skills" ||
        reportType === "skills_report"
      ) {
        if (!skillsData || skillsData.length === 0) {
          setSkillsLoading(true);
          try {
            const result = await dispatch(fetchAllEmployeeSkills()).unwrap();

            if (result.status === "success" && Array.isArray(result.data)) {
              setSkillsData(result.data);
            } else if (Array.isArray(result)) {
              setSkillsData(result);
            } else {
              console.error(
                "Unexpected response format for skills report:",
                result
              );
              exportRequestRef.current = null;
            }
          } catch (error) {
            console.error("Error fetching skills report data:", error);
            exportRequestRef.current = null;
          } finally {
            setSkillsLoading(false);
          }
          return;
        }
        processExport(reportType, format);
      } else if (reportType === "employee_timesheet") {
        if (!employeeTimesheetData || employeeTimesheetData.length === 0) {
          setEmployeeTimesheetLoading(true);
          try {
            const result = await dispatch(fetchAllEmployeeData()).unwrap();

            if (Array.isArray(result.data))
              setEmployeeTimesheetData(result.data);
            else if (Array.isArray(result)) setEmployeeTimesheetData(result);
            else
              console.error(
                "Unexpected format for employee timesheet:",
                result
              );
          } catch (error) {
            console.error("Error fetching employee timesheet:", error);
          } finally {
            setEmployeeTimesheetLoading(false);
          }
          return;
        }

        processExport(reportType, format);
      } else if (reportType === "project_report") {
        if (!projectData || projectData.length === 0) {
          setProjectLoading(true);
          try {
            const result = await dispatch(fetchAllProjectReport()).unwrap();

            if (Array.isArray(result.data)) setProjectData(result.data);
            else if (Array.isArray(result)) setProjectData(result);
            else console.error("Unexpected format for Project Report:", result);
          } catch (error) {
            console.error("Error fetching Project Report:", error);
          } finally {
            setProjectLoading(false);
          }
          return;
        }

        processExport(reportType, format);
      } else if (reportType === "task" || reportType === "task_report") {
        if (!taskData || taskData.length === 0) {
          setTaskLoading(true);
          try {
            const result = await dispatch(fetchAllTaskList()).unwrap();

            if (
              result &&
              result.status === "success" &&
              Array.isArray(result.data)
            ) {
              setTaskData(result.data);
            } else if (Array.isArray(result)) {
              setTaskData(result);
            } else if (result && Array.isArray(result.data)) {
              setTaskData(result.data);
            } else {
              console.error(
                "Unexpected response format for task report:",
                result
              );
              exportRequestRef.current = null;
              processExport(reportType, format);
            }
          } catch (error) {
            console.error("Error fetching task report data:", error);
            exportRequestRef.current = null;
            processExport(reportType, format);
          } finally {
            setTaskLoading(false);
          }
          return;
        }
        processExport(reportType, format);
      } else if (reportType === "budget_report") {
        if (!budgetData || budgetData.length === 0) {
          dispatch(fetchAllBudgets());
          return;
        }
        processExport(reportType, format);
      } else if (reportType === "asset_report") {
        if (!assetData || assetData.length === 0) {
          dispatch(fetchAllAllocations());
          return;
        }
        processExport(reportType, format);
      }
      else if (reportType === "training_report") {
        if (!trainingData || trainingData.length === 0) {
          dispatch(fetchAlltraininglist());
          return;
        }
        processExport(reportType, format);
      }
      else if (reportType === "attendance_report") {
        if (!attendanceReportData || attendanceReportData.length === 0) {
          setAttendanceReportLoading(true);
          try {
            const result = await dispatch(fetchAllattendanceReport()).unwrap();

            if (result.status === "success" && Array.isArray(result.data)) {
              setAttendanceReportData(result.data);
            } else if (Array.isArray(result)) {
              setAttendanceReportData(result);
            } else if (result && Array.isArray(result.data)) {
              setAttendanceReportData(result.data);
            } else {
              console.error(
                "Unexpected response format for attendance report:",
                result
              );
              exportRequestRef.current = null;
              processExport(reportType, format);
            }
          } catch (error) {
            console.error("Error fetching attendance report data:", error);
            exportRequestRef.current = null;
            processExport(reportType, format);
          } finally {
            setAttendanceReportLoading(false);
          }
          return;
        }

        processExport(reportType, format);
      }
      else if (reportType === "tds" || reportType === "tds_report") {
        if (!tdsReportData || tdsReportData.length === 0) {
          setTdsReportLoading(true);
          try {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;

            const result = await dispatch(
              fetchAllTDSAction({ year, month })
            ).unwrap();

            if (result.status === "success" && Array.isArray(result.data)) {
              setTdsReportData(result.data);
            } else if (Array.isArray(result)) {
              setTdsReportData(result);
            } else if (result && Array.isArray(result.data)) {
              setTdsReportData(result.data);
            } else {
              console.error(
                "Unexpected response format for TDS report:",
                result
              );
              exportRequestRef.current = null;
              processExport(reportType, format);
            }
          } catch (error) {
            console.error("Error fetching TDS report data:", error);
            exportRequestRef.current = null;
            processExport(reportType, format);
          } finally {
            setTdsReportLoading(false);
          }
          return;
        }
        processExport(reportType, format);
      } else if (reportType === "maintenance_report") {
        if (!maintenanceData || maintenanceData.length === 0) {
          dispatch(fetchAllMaintenances());
          return;
        }
        processExport(reportType, format);
      } else {
        console.warn("Unknown report type:", reportType);
        exportRequestRef.current = null;
      }
    };

    window.addEventListener("ai-export-trigger", handler);

    return () => {
      window.removeEventListener("ai-export-trigger", handler);
    };
  }, [
    employees,
    leaveData,
    salaryTransactions,
    selectExpenses,
    userData,
    offboardingData,
    payslipData,
    employeeReportData,
    skillsData,
    employeeTimesheetData,
    projectData,
    taskData,
    budgetData,
    assetData,
    maintenanceData,
    trainingData,
    attendanceReportData,
    leaveledgerData,
    tdsReportData,
    dispatch,
  ]);
  useEffect(() => {
    if (exportRequestRef.current) {
      const { reportType, format } = exportRequestRef.current;

      if (
        reportType === "employee" &&
        !employeeLoading &&
        employees.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "leave" &&
        !leaveLoading &&
        leaveData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "salary" &&
        !salaryLoading &&
        salaryTransactions.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "expense" &&
        !selectExpenseLoading.fetchAll &&
        selectExpenses.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (reportType === "user" && !userLoading && userData.length > 0) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "payslip" &&
        !payslipLoading &&
        payslipData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        (reportType === "employee_report" || reportType === "employeeReport") &&
        !employeeReportLoading &&
        employeeReportData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        (reportType === "offboarding" || reportType === "offboarding_report") &&
        !offboardingLoading &&
        offboardingData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "leaveledger" &&
        !leaveledgerLoading &&
        leaveledgerData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      }
      else if (
        (reportType === "skills" ||
          reportType === "employee_skills" ||
          reportType === "skills_report") &&
        !skillsLoading &&
        skillsData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "employee_timesheet" &&
        !employeeTimesheetLoading &&
        employeeTimesheetData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "project_report" &&
        !projectLoading &&
        projectData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        (reportType === "task" || reportType === "task_report") &&
        !taskLoading &&
        taskData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      }
      else if (
        reportType === "budget_report" &&
        !budgetLoading?.fetchAll &&
        budgetData &&
        budgetData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "asset_report" &&
        !assetLoading &&
        assetData &&
        assetData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        reportType === "tds_report" &&
        !tdsReportLoading &&
        tdsReportData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        (reportType === "maintenance" ||
          reportType === "asset_maintenance" ||
          reportType === "maintenance_report") &&
        !maintenanceLoading &&
        maintenanceData &&
        maintenanceData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      } else if (
        (reportType === "training" || reportType === "training_report") &&
        !trainingLoading &&
        trainingData &&
        trainingData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      }
      else if (
        (reportType === "attendance" || reportType === "attendance_report") &&
        !attendanceReportLoading &&
        attendanceReportData.length > 0
      ) {
        processExport(reportType, format);
        exportRequestRef.current = null;
      }
    }
  }, [
    employeeLoading,
    leaveLoading,
    salaryLoading,
    selectExpenseLoading,
    selectExpenses,
    userData,
    userLoading,
    payslipLoading,
    payslipData,
    employeeReportLoading,
    employeeReportData,
    offboardingLoading,
    offboardingData,
    skillsLoading,
    skillsData,
    employees,
    leaveData,
    salaryTransactions,
    employeeTimesheetLoading,
    employeeTimesheetData,
    projectLoading,
    projectData,
    taskLoading,
    taskData,
    budgetLoading,
    budgetData,
    assetLoading,
    assetData,
    maintenanceLoading,
    maintenanceData,
    trainingLoading,
    trainingData,
    attendanceReportLoading,
    attendanceReportData,
    leaveledgerData,
    leaveledgerLoading,
    tdsReportLoading,
    tdsReportData,
  ]);

  // Export function
  const processExport = (reportType: string, format: string) => {
    let data: any[] = [];
    let filename = "";

    if (reportType === "employee") {
      data = formattedEmployeeData || [];
      filename = "employee_report";
    } else if (reportType === "leave") {
      data = formattedLeaveData || [];
      filename = "leave_report";
    } else if (reportType === "salary") {
      data = formattedSalaryData || [];
      filename = "salary_report";
    } else if (reportType === "expense") {
      data = formattedExpenseData || [];
      filename = "expense_report";
    } else if (reportType === "user") {
      data = formattedUserData || [];
      filename = "user_report";
    } else if (reportType === "payslip") {
      data = formattedPayslipData || [];
      filename = "payslip_report";
    } else if (
      reportType === "employee_report" ||
      reportType === "employeeReport"
    ) {
      data = formattedEmployeeReportData || [];
      filename = "employee_summary_report";
    } else if (
      reportType === "offboarding" ||
      reportType === "offboarding_report"
    ) {
      data = formattedOffboardingData || [];
      filename = `offboarding_report_${new Date().getFullYear()}`;
    } else if (reportType === "skills") {
      data = formattedSkillsData || [];
      filename = "employee_skills_report";
    } else if (reportType === "employee_timesheet") {
      data = formattedEmployeeTimesheet;
      filename = "employee_timesheet_report";
    } else if (reportType === "project_report") {
      data = formattedProjectData;
      filename = "project_report";
    } else if (reportType === "task" || reportType === "task_report") {
      data = formattedTaskData || [];
      filename = "task_report";
    } else if (reportType === "budget_report") {
      data = formattedBudgetData || [];
      filename = "budget_report";
    } else if (reportType === "asset_report") {
      data = formattedAssetData || [];
      filename = "asset_allocation_report";
    } else if (reportType === "maintenance_report") {
      data = formattedMaintenanceData || [];
      filename = "asset_maintenance_report";
    } else if (reportType === "training_report") {
      data = formattedTrainingData || [];
      filename = "training_report";
    } else if (reportType === "leaveledger") {
      data = formattedleaveledgerData || [];
      filename = "leaveledger_report";
    } else if (
      reportType === "attendance" ||
      reportType === "attendance_report"
    ) {
      data = formattedAttendanceReportData || [];
      filename = `attendance_report_${new Date().getFullYear()}_${new Date().getMonth() + 1}`;
    } else if (reportType === "tds_report") {
      data = formattedTDSReportData || [];
      filename = `tds_report_${new Date().getFullYear()}_${new Date().getMonth() + 1}`;
    } else {
      console.warn("Unknown report type:", reportType);
      return;
    }

    if (data.length === 0) {
      console.warn(`No data available for ${reportType} export`);
      return;
    }

    try {
      if (format === "csv") {
        exportToCSV(data, filename);
      } else {
        exportToExcel(data, filename);
      }
    } catch (error) {
      console.error(`Error in ${reportType} export:`, error);
    }
  };

  return null;
}
